const DEPARTMENT = {
  SURVEY: 'survey',
  FINANCES: 'finances',
  ASSIGN_ID: 'assignId',
  LEGALIZATION: 'legalization',
  LEGALIZATION_DOCUMENTS: 'legalizationDocuments',
  REGISTER: 'register',
  LEAD: 'lead',
  LEAD_KARA: 'leadKara',
  LEAD_VITYA: 'leadVitya',
  CALL: 'call',
  UZB: 'uzb',
  PARKING: 'parking',
  SHERIFF: 'sheriff',
  LEAD_FOLLOW_UP: 'leadFollowUp',
  PROMO: 'promo',
  VELOBRO: 'velobro',
  UA_HUB: 'uaHub',
  AMBASADOR_TAXI: 'ambasadorTaxi',
  B2B_REFERRAL: 'b2bReferral',
  MILAN_WROCLAW: 'milanWroclaw',
  BLOGGER_MARCHENKO: 'bloggerMarchenko',
  RAZEDEN: 'razeden',
  MERDAN_BIALYSTOK: 'merdanBialystok',
  SERGEY_AMB: 'sergeyAmb',
  ROMANICH_AMB: 'romanichAmb',
  XISRAV_AMB: 'xisravAmb',
  TAXI_AMB: 'taxiAmb',
  IVAN_AMB: 'ivanAmb',
  STANDUP_SERGEI: 'standupSergei',
  AMB_COURIER: 'ambCourier',
  SHLEM_SHADY: 'shlemShady',
  ZHIZN_KURIERA: 'zhiznKuriera',
  YAROSLAV_PAVLYK: 'yaroslavPavlyk',
  DANEELISCHE: 'daneelische',
  KURIER_COROLLA: 'kurierCorolla',
  INVOICE: 'invoice',
  AI_CASE: 'aiCase',
  GDANSK_LEGALIZATION: 'gdanskLegalization',
  KRAKOW_LEGALIZATION: 'krakowLegalization',
  ARCHIVE_REGISTER: 'archiveRegister',
  ARCHIVE_FINANCES: 'archiveFinances',
  ARCHIVE_LEAD_FOLLOW_UP: 'archiveLeadFollowUp',
  ARCHIVE_LEGALIZATION: 'archiveLegalization',
};

const DEPARTMENTS = [
  {
    id: DEPARTMENT.SURVEY,
    name: 'Договора',
    color: 'green',
    icon: 'mdi-format-list-bulleted',
  },
  {
    id: DEPARTMENT.FINANCES,
    name: 'Финансы',
    color: 'pink',
    icon: 'mdi-finance',
  },
  {
    id: DEPARTMENT.ASSIGN_ID,
    name: 'Приписать ключ',
    color: 'cyan',
    icon: 'mdi-key',
  },
  {
    id: DEPARTMENT.ARCHIVE_FINANCES,
    name: 'Архив Финансы',
    color: 'blue-grey darken-1',
    icon: 'mdi-finance',
  },
  {
    id: DEPARTMENT.LEGALIZATION,
    name: 'Кадры ЛГ',
    color: 'orange',
    icon: 'mdi-passport',
  },
  {
    id: DEPARTMENT.LEGALIZATION_DOCUMENTS,
    name: 'Wypis/ID ЛГ',
    color: 'red',
    icon: 'mdi-taxi',
  },
  {
    id: DEPARTMENT.REGISTER,
    name: 'Регистрации',
    color: 'purple lighten-3',
    icon: 'mdi-account-plus',
  },
  {
    id: DEPARTMENT.LEAD,
    name: 'Лиды',
    color: 'indigo',
    icon: 'mdi-cash',
  },
  {
    id: DEPARTMENT.LEAD_KARA,
    name: 'Лиды Кара',
    color: 'orange lighten-1',
    icon: 'ЛК',
  },
  {
    id: DEPARTMENT.LEAD_VITYA,
    name: 'Лиды Виталик',
    color: 'light-green darken-1',
    icon: 'ЛВ',
  },
  {
    id: DEPARTMENT.CALL,
    name: 'Звонки',
    color: 'teal',
    icon: 'mdi-phone',
  },
  {
    id: DEPARTMENT.UZB,
    name: 'UZB',
    color: 'teal',
    icon: '🇺🇿',
    hasComplexFilter: true,
  },
  {
    id: DEPARTMENT.PARKING,
    name: 'Автопарки',
    color: 'blue-grey darken-2',
    icon: 'mdi-parking',
    hasComplexFilter: true,
  },
  {
    id: DEPARTMENT.SHERIFF,
    name: 'Шериф',
    color: 'orange lighten-2',
    icon: 'mdi-police-badge-outline',
  },
  {
    id: DEPARTMENT.LEAD_FOLLOW_UP,
    name: 'Чаты',
    color: 'pink lighten-2',
    icon: 'mdi-chat-alert-outline',
  },
  {
    id: DEPARTMENT.PROMO,
    name: 'Промо',
    color: 'brown lighten-1',
    icon: 'mdi-star-circle-outline',
  },
  {
    id: DEPARTMENT.VELOBRO,
    name: 'VeloBro',
    color: 'blue lighten-1',
    icon: 'mdi-bike',
  },
  {
    id: DEPARTMENT.UA_HUB,
    name: 'UAhub',
    color: 'yellow darken-4',
    icon: 'UA',
  },
  {
    id: DEPARTMENT.AMBASADOR_TAXI,
    name: 'Smolin Taxi',
    color: 'teal lighten-2',
    icon: 'ST',
  },
  {
    id: DEPARTMENT.B2B_REFERRAL,
    name: 'B2B Referral',
    color: 'cyan lighten-1',
    icon: 'B2B',
  },
  {
    id: DEPARTMENT.MILAN_WROCLAW,
    name: 'Milan Wrocław',
    color: 'cyan lighten-1',
    icon: 'MW',
  },
  {
    id: DEPARTMENT.BLOGGER_MARCHENKO,
    name: 'Блогер Марченко',
    color: 'cyan lighten-1',
    icon: 'BM',
  },
  {
    id: DEPARTMENT.RAZEDEN,
    name: 'Razeden',
    color: 'cyan lighten-1',
    icon: 'RZ',
  },
  {
    id: DEPARTMENT.MERDAN_BIALYSTOK,
    name: 'Merdan Białystok',
    color: 'cyan lighten-1',
    icon: 'MB',
  },
  {
    id: DEPARTMENT.SERGEY_AMB,
    name: 'Sergey AMB',
    color: 'cyan lighten-1',
    icon: 'SA',
  },
  {
    id: DEPARTMENT.ROMANICH_AMB,
    name: 'Romanich AMB',
    color: 'cyan lighten-1',
    icon: 'RA',
  },
  {
    id: DEPARTMENT.XISRAV_AMB,
    name: 'Xisrav AMB',
    color: 'cyan lighten-1',
    icon: 'XA',
  },
  {
    id: DEPARTMENT.TAXI_AMB,
    name: 'Taxi AMB',
    color: 'cyan lighten-1',
    icon: 'TA',
  },
  {
    id: DEPARTMENT.IVAN_AMB,
    name: 'Ivan AMB',
    color: 'cyan lighten-1',
    icon: 'IA',
  },
  {
    id: DEPARTMENT.STANDUP_SERGEI,
    name: 'Standup Sergei',
    color: 'cyan lighten-1',
    icon: 'SS',
  },
  {
    id: DEPARTMENT.AMB_COURIER,
    name: 'AMB Courier',
    color: 'cyan lighten-1',
    icon: 'AC',
  },
  {
    id: DEPARTMENT.SHLEM_SHADY,
    name: 'Shlem Shady',
    color: 'cyan lighten-1',
    icon: 'SH',
  },
  {
    id: DEPARTMENT.ZHIZN_KURIERA,
    name: 'Zhizn Kuriera',
    color: 'cyan lighten-1',
    icon: 'ZK',
  },
  {
    id: DEPARTMENT.YAROSLAV_PAVLYK,
    name: 'Yaroslav Pavlyk',
    color: 'cyan lighten-1',
    icon: 'YP',
  },
  {
    id: DEPARTMENT.DANEELISCHE,
    name: 'Daneelische',
    color: 'cyan lighten-1',
    icon: 'DN',
  },
  {
    id: DEPARTMENT.KURIER_COROLLA,
    name: 'Kurier Corolla',
    color: 'cyan lighten-1',
    icon: 'KC',
  },
  {
    id: DEPARTMENT.INVOICE,
    name: 'Фактуры',
    color: 'purple lighten-1',
    icon: 'mdi-file-document-outline',
  },
  {
    id: DEPARTMENT.AI_CASE,
    name: 'AI case',
    color: 'deep-purple lighten-1',
    icon: 'mdi-robot-outline',
  },
  {
    id: DEPARTMENT.GDANSK_LEGALIZATION,
    name: 'Gdańsk Кадры ЛГ',
    color: 'indigo lighten-1',
    icon: 'mdi-waves',
  },
  {
    id: DEPARTMENT.KRAKOW_LEGALIZATION,
    name: 'Kraków Кадры ЛГ',
    color: 'orange lighten-1',
    icon: 'mdi-castle',
  },
  {
    id: DEPARTMENT.ARCHIVE_LEGALIZATION,
    name: 'Архив Кадры ЛГ',
    color: 'blue-grey darken-1',
    icon: 'mdi-passport',
  },
  {
    id: DEPARTMENT.ARCHIVE_REGISTER,
    name: 'Архив Регистрации',
    color: 'blue-grey darken-1',
    icon: 'mdi-account-plus',
  },
  {
    id: DEPARTMENT.ARCHIVE_LEAD_FOLLOW_UP,
    name: 'Архив Чаты',
    color: 'blue-grey darken-1',
    icon: 'mdi-chat-alert-outline',
  },
];

export { DEPARTMENT, DEPARTMENTS };
